import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSortDown,
  faHome,
  faDollarSign,
  faShoppingCart,
  faCog,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

const DashboardSidebar = () => {
  const [openMenu, setOpenMenu] = useState(null);

  const handleMenuToggle = (menuIndex) => {
    setOpenMenu(openMenu === menuIndex ? null : menuIndex);
  };

  const liStyle = "p-3 ps-5 text-decoration-none text-white";
  const activeLinkStyle = "p-3 ps-5 text-decoration-none text-white active";

  const menuItems = [
    {
      id: 1,
      icon: faHome,
      label: "House System",
      subMenu: [
        { path: "/dashboard", label: "Dashboard" },
        { path: "/searchBorrower", label: "Search Borrower" },
        { path: "/addEditBorrower", label: "Add / Edit Borrower" },
        { path: "/viewBorrower", label: "View Borrower" },
        { path: "/newInvoice", label: "New Invoice" },
        { path: "/searchInvoices", label: "Search Invoice" },
        { path: "/housePlans", label: "House Plans" },
      ],
    },
    {
      id: 2,
      icon: faDollarSign,
      label: "Expenses",
      subMenu: [
        { path: "/searchExpenses", label: "Search Expenses" },
        { path: "/addEditExpenses", label: "Add / Edit Expenses" },
        { path: "/viewExpenses", label: "View Expenses" },
        { path: "/addEditCaExpenses", label: "Add / Edit CA Expenses" },
        { path: "/searchCaExpenses", label: "Search CA Expenses" },
        { path: "/searchCategory", label: "Search Categories" },
      ],
    },
    {
      id: 3,
      icon: faShoppingCart,
      label: "Store",
      subMenu: [
        { path: "/addEditProducts", label: "Add / Edit Product" },
        { path: "/searchProduct", label: "Search Product" },
        { path: "/searchOrders", label: "Search Orders" },
      ],
    },
    {
      id: 4,
      icon: faCog,
      label: "Setting",
      subMenu: [
        { path: "/formulas", label: "Formulas" },
        { path: "/editHouseAgreement", label: "Edit House Agreement" },
        { path: "/general", label: "General" },
        { path: "/allBanners", label: "All Banners" },
        { path: "/printInvoices", label: "Print Invoice" },
        { path: "/taxonomies", label: "Taxonomies" },
      ],
    },
    {
      id: 5,
      icon: faUser,
      label: "Users",
      subMenu: [
        { path: "/yourProfile", label: "Your Profile" },
        { path: "/updatePassword", label: "Update Password" },
      ],
    },
  ];

  return (
    <div className="dashboard_navbar py-3">
      <nav>
        <ul className="list-unstyled m-0 p-0 dashboard_main_ul">
          {menuItems.map(({ id, icon, label, subMenu }) => (
            <li key={id} className="py-2">
              <span
                onClick={() => handleMenuToggle(id)}
                className="px-4 py-2 dashboard_links"
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon icon={icon} style={{ marginRight: "10px" }} />
                {label}
                <FontAwesomeIcon
                  icon={faSortDown}
                  style={{ marginLeft: "5px" }}
                />
              </span>
              {openMenu === id && (
                <div
                  className="dashboard_sub_navbar"
                  style={{ display: "block" }}
                >
                  <ul className="list-unstyled dashboard_sub_ul">
                    {subMenu.map(({ path, label }) => (
                      <li key={path} className="dashboard_links">
                        <NavLink
                          to={path}
                          className={({ isActive }) =>
                            isActive ? activeLinkStyle : liStyle
                          }
                        >
                          {label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default DashboardSidebar;
